(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initAllHibaEstimators() {
    var estimators = document.querySelectorAll('[data-hiba-estimator]');

    estimators.forEach(function (estimator) {
      initHibaEstimator(estimator);
    });
  }

  function initHibaEstimator(estimator) {
    if (!estimator || estimator.dataset.hibaEstimatorReady === 'true') return;

    var projectInput = estimator.querySelector('[data-hiba-estimator-project]');
    var sizeInput = estimator.querySelector('[data-hiba-estimator-size]');
    var lengthInput = estimator.querySelector('[data-hiba-estimator-length]');
    var fullnessInput = estimator.querySelector('[data-hiba-estimator-fullness]');
    var sleevesInput = estimator.querySelector('[data-hiba-estimator-sleeves]');
    var roleInput = estimator.querySelector('[data-hiba-estimator-role]');
    var extraInput = estimator.querySelector('[data-hiba-estimator-extra]');

    var rangeOutput = estimator.querySelector('[data-hiba-estimator-range]');
    var yardsOutput = estimator.querySelector('[data-hiba-estimator-yards]');
    var recommendedOutput = estimator.querySelector('[data-hiba-estimator-recommended]');
    var widthNote = estimator.querySelector('[data-hiba-estimator-width-note]');
    var useButton = estimator.querySelector('[data-hiba-estimator-use]');

    if (
      !projectInput ||
      !sizeInput ||
      !lengthInput ||
      !fullnessInput ||
      !sleevesInput ||
      !roleInput ||
      !extraInput ||
      !rangeOutput ||
      !yardsOutput ||
      !recommendedOutput ||
      !useButton
    ) {
      return;
    }

    estimator.dataset.hibaEstimatorReady = 'true';

    var orderedInputs = [
      projectInput,
      sizeInput,
      lengthInput,
      fullnessInput,
      sleevesInput,
      roleInput,
      extraInput
    ];

    var stepLabels = [
      'Select project type',
      'Select size / fit',
      'Select length',
      'Select fullness',
      'Select sleeves',
      'Select fabric use',
      'Select allowance'
    ];

    var unitSize = parseFloat(estimator.dataset.unitSize || '0.5');
    var rawFabricWidth = String(estimator.dataset.fabricWidth || '').trim();

    var currentRecommendedMeters = unitSize;

    var projects = {
      evening_dress: { base: 4.0 },
      party_dress: { base: 2.6 },
      abaya_kaftan: { base: 3.6 },
      skirt: { base: 2.1 },
      blouse_top: { base: 1.45 },
      pants: { base: 2.5 },
      jumpsuit: { base: 3.4 },
      overlay_veil: { base: 2.1 },
      dancewear: { base: 1.35 }
    };

    function parseFabricWidth(value) {
      var match = String(value || '').replace(',', '.').match(/[\d.]+/);
      var number = match ? parseFloat(match[0]) : NaN;

      return Number.isFinite(number) && number > 0 ? number : null;
    }

    var fabricWidth = parseFabricWidth(rawFabricWidth);
    var calculationWidth = fabricWidth || 150;

    function formatMeters(value) {
      var number = Number(value);
      if (!Number.isFinite(number)) return '0';

      return String(Number(number.toFixed(2)))
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1');
    }

    function roundUpToStep(value, step) {
      var safeStep = Number.isFinite(step) && step > 0 ? step : 0.5;
      return Number((Math.ceil((value - 0.000001) / safeStep) * safeStep).toFixed(2));
    }

    function widthMultiplier(width) {
      if (!Number.isFinite(width) || width <= 0) return 1;
      if (width <= 110) return 1.25;
      if (width <= 130) return 1.15;
      if (width <= 145) return 1.08;

      return 1;
    }

    function yards(meters) {
      return meters * 1.09361;
    }

    function firstIncompleteIndex() {
      for (var i = 0; i < orderedInputs.length; i += 1) {
        if (!orderedInputs[i] || !orderedInputs[i].value) {
          return i;
        }
      }

      return -1;
    }

    function updateStepAvailability() {
      for (var i = 0; i < orderedInputs.length; i += 1) {
        if (i === 0) {
          orderedInputs[i].disabled = false;
          continue;
        }

        var previousFilled = orderedInputs[i - 1] && orderedInputs[i - 1].value;
        var allBeforeFilled = orderedInputs.slice(0, i).every(function (input) {
          return input && input.value;
        });

        orderedInputs[i].disabled = !(previousFilled && allBeforeFilled);
      }

      useButton.disabled = firstIncompleteIndex() !== -1;
    }

    function resetFieldsAfter(index) {
      for (var i = index + 1; i < orderedInputs.length; i += 1) {
        if (orderedInputs[i]) {
          orderedInputs[i].value = '';
        }
      }
    }

    function showProgressState() {
      var missingIndex = firstIncompleteIndex();

      updateStepAvailability();

      if (missingIndex === -1) {
        calculateEstimate();
        return;
      }

      rangeOutput.textContent = stepLabels[missingIndex] || 'Complete the estimator';
      rangeOutput.classList.add('is-placeholder');

      yardsOutput.textContent = 'Continue each step to calculate your fabric estimate.';
      recommendedOutput.textContent = '—';

      if (widthNote) {
        if (fabricWidth) {
          widthNote.textContent =
            'Estimate will use this product’s fabric width: ' +
            formatMeters(fabricWidth) +
            ' cm.';
        } else {
          widthNote.textContent =
            'Fabric width is not set for this product, so the estimate will use a standard 150 cm width.';
        }
      }
    }

    function calculateEstimate() {
      updateStepAvailability();

      if (firstIncompleteIndex() !== -1) {
        showProgressState();
        return;
      }

      var project = projects[projectInput.value] || projects.evening_dress;

      var sizeFactor = parseFloat(sizeInput.value || '1');
      var lengthFactor = parseFloat(lengthInput.value || '1');
      var fullnessFactor = parseFloat(fullnessInput.value || '1');
      var sleevesExtra = parseFloat(sleevesInput.value || '0');
      var roleFactor = parseFloat(roleInput.value || '1');
      var extraAllowance = parseFloat(extraInput.value || '0.3');
      var widthFactor = widthMultiplier(calculationWidth);

      var estimate = project.base;

      estimate = estimate * sizeFactor;
      estimate = estimate * lengthFactor;
      estimate = estimate * fullnessFactor;
      estimate = estimate * roleFactor;
      estimate = estimate * widthFactor;
      estimate = estimate + sleevesExtra + extraAllowance;

      var lowMeters = Math.max(unitSize, roundUpToStep(estimate * 0.88, unitSize));
      var highMeters = Math.max(unitSize, roundUpToStep(estimate * 1.08, unitSize));
      var recommendedMeters = Math.max(unitSize, roundUpToStep(highMeters, unitSize));

      currentRecommendedMeters = recommendedMeters;

      rangeOutput.classList.remove('is-placeholder');
      rangeOutput.textContent = formatMeters(lowMeters) + '–' + formatMeters(highMeters) + ' m';

      yardsOutput.textContent =
        yards(lowMeters).toFixed(2) +
        '–' +
        yards(highMeters).toFixed(2) +
        ' yd';

      recommendedOutput.textContent = formatMeters(recommendedMeters) + ' m';

      if (widthNote) {
        if (fabricWidth) {
          widthNote.textContent =
            'Estimate uses this product’s fabric width: ' +
            formatMeters(fabricWidth) +
            ' cm.';
        } else {
          widthNote.textContent =
            'Fabric width is not set for this product, so this estimate uses a standard 150 cm width.';
        }
      }
    }

    function resetEstimatorOnLoad() {
      orderedInputs.forEach(function (input, index) {
        if (!input) return;

        input.value = '';
        input.disabled = index !== 0;
      });

      currentRecommendedMeters = unitSize;
      useButton.disabled = true;

      showProgressState();
    }

    function applyToMeterSelector() {
      if (firstIncompleteIndex() !== -1) return;

      var meterButton = document.querySelector('[data-hiba-mode="meter"]');
      var qtyInput = document.querySelector('[data-hiba-display-qty]');

      if (!qtyInput) {
        window.alert('Meter selector was not found on this page.');
        return;
      }

      if (meterButton && !meterButton.classList.contains('is-active')) {
        meterButton.click();
      }

      window.setTimeout(function () {
        qtyInput.value = formatMeters(currentRecommendedMeters);

        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

        qtyInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        qtyInput.focus();
      }, 120);
    }

    orderedInputs.forEach(function (input, index) {
      if (!input) return;

      input.addEventListener('change', function () {
        resetFieldsAfter(index);
        showProgressState();
      });
    });

    useButton.addEventListener('click', applyToMeterSelector);

    resetEstimatorOnLoad();

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        resetEstimatorOnLoad();
      }
    });
  }

  function boot() {
    initAllHibaEstimators();

    window.setTimeout(initAllHibaEstimators, 250);
    window.setTimeout(initAllHibaEstimators, 700);
    window.setTimeout(initAllHibaEstimators, 1400);
  }

  ready(boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();